import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';

export const SET_BUY_PACKAGE_AUTO_PROLONG = 'BUY_PACKAGE :: AUTO_PROLONG';

interface IBuyPackageAutoProlong {
  autoProlong: boolean;
}

export type TSetBuyPackageAutoProlongAction = IReduxAction<typeof SET_BUY_PACKAGE_AUTO_PROLONG, IBuyPackageAutoProlong>;

export const setBuyPackageAutoProlong = actionGenerator<typeof SET_BUY_PACKAGE_AUTO_PROLONG, IBuyPackageAutoProlong>(
  SET_BUY_PACKAGE_AUTO_PROLONG,
);
